import {
    pdfDocumentImg,
    sevenZipDocumentImg,
    csvDocumentImg,
    docxDocumentImg,
    pptDocumentImg,
    pptxDocumentImg,
    rarDocumentImg,
    txtDocumentImg,
    xlsDocumentImg,
    xlsxDocumentImg,
    zipDocumentImg,
    imageDocumentImg,
    unknownDocumentImg,
} from '../img/images';

export const getFileExtension = (fileName: string | undefined): string => {
    if (fileName === undefined) {
        return '';
    }

    const fileExtensionStartIndex = fileName.lastIndexOf('.');
    return fileExtensionStartIndex === undefined
        ? ''
        : fileExtensionStartIndex > -1
        ? fileName.substring(fileExtensionStartIndex, fileName.length)
        : '';
};

export const getFileTypeIcon = (fileExtension: string): string => {
    let retVal = '';
    switch (fileExtension) {
        case '.pdf': {
            retVal = pdfDocumentImg;
            break;
        }
        case '.docx': {
            retVal = docxDocumentImg;
            break;
        }
        case '.doc': {
            retVal = docxDocumentImg;
            break;
        }
        case '.csv': {
            retVal = csvDocumentImg;
            break;
        }
        case '.7z': {
            retVal = sevenZipDocumentImg;
            break;
        }
        case '.ppt': {
            retVal = pptDocumentImg;
            break;
        }
        case '.pptx': {
            retVal = pptxDocumentImg;
            break;
        }
        case '.rar': {
            retVal = rarDocumentImg;
            break;
        }
        case '.txt': {
            retVal = txtDocumentImg;
            break;
        }
        case '.xls': {
            retVal = xlsDocumentImg;
            break;
        }
        case '.xlsx': {
            retVal = xlsxDocumentImg;
            break;
        }
        case '.zip': {
            retVal = zipDocumentImg;
            break;
        }
        case '.jpg':
        case '.jpeg':
        case '.png':
        case '.gif': {
            retVal = imageDocumentImg;
            break;
        }
        default: {
            retVal = unknownDocumentImg;
        }
    }
    return retVal;
};
